var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "nav-list" },
    [
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-skeleton-loader",
                    {
                      attrs: {
                        loading: _vm.isLoading,
                        transition: "expand-transition",
                        type: "article",
                      },
                    },
                    [
                      _c("FormVehicle", {
                        attrs: {
                          Vehicle: _vm.editVehicle,
                          isSaving: _vm.isSaving,
                        },
                        on: {
                          save: _vm.save,
                          cancel: function ($event) {
                            return _vm.$router.push({ name: _vm.from.name })
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.editVehicle.id
                    ? _c("ListVehiclePart", {
                        attrs: { "vehicle-id": _vm.editVehicle.id },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }